export default "__VITE_ASSET__Bd48lQOc__"